

export const SET_LOGIN_STATE = "SET_LOGIN_STATE";
export const SET_COMPANIES_STATE = "SET_COMPANIES_STATE";
export const SET_SELECTED_COMPANY="SET_SELECTED_COMPANY";
export const SET_CLIENTS_STATE="SET_CLIENTS_STATE";
export const SET_ITEMS_STATE="SET_ITEMS_STATE";
export const SET_SELECTED_CLIENT="SET_SELECTED_CLIENT";
export const SET_SELECTED_ITEM="SET_SELECTED_ITEM";